export default __webpack_public_path__ + "static/media/035-box.00804b29.svg";